// extracted by mini-css-extract-plugin
module.exports = {"date-group":"date-group__7rvFh"};